import React from "react";
import { Outlet, useOutletContext, useParams } from "react-router-dom";

import { db } from "astrid-firebase";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import LoadingContext from "../../ui/components/LoadingContext/LoadingContext";

import featureFlags from "../../authorization/constants/featureFlags";

import DistributionView from "../views/DistributionView/DistributionView";

export default function Distribution() {
	const params = useParams();
	const { organization, article } = useOutletContext();

	const [distribution, loading, error] = useDocumentData(db.collection("distributions").doc(params.distribution));

	return (
		<LoadingContext data={distribution} loading={loading} error={error} featureFlag={featureFlags.FLATTENING}>
			<DistributionView organization={organization} article={article} distribution={distribution}>
				<Outlet context={{ organization, article, distribution }} />
			</DistributionView>
		</LoadingContext>
	);
}
